module.exports = __webpack_public_path__ + "static/media/undraw.f5399086.png";